import React from 'react'

import { ICellRendererParams } from 'ag-grid-community'

export function HubSpotLinkRenderer(params: ICellRendererParams) {
  const { data } = params
  const { hubspot_contact_id } = data ?? {}

  return (
    <div className='text-center'>
      {hubspot_contact_id ? (
        <a
          className='hover:underline text-blue-600 hover:text-blue-800'
          target='_blank'
          rel='noopener noreferrer'
          href={`https://app.hubspot.com/contacts/47305776/record/0-1/${hubspot_contact_id}`}
        >
          {hubspot_contact_id}
        </a>
      ) : (
        <span className='text-gray-500'>-</span>
      )}
    </div>
  )
}
